import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ko from "./ko.json";
import en from "./en.json";
import ja from "./ja.json";

const userLang = window.__DEVICE__?.language || "ko";

export const initI18n = () => {
  i18n.use(initReactI18next).init({
    resources: {
      ko: { translation: ko },
      en: { translation: en },
      ja: { translation: ja },
    },
    lng: userLang,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

  // html lang 동기화 — :lang() CSS 셀렉터가 동작하려면 필요
  // (특히 일본어는 word-break 동작이 한국어/영어와 달라 분기 필요)
  document.documentElement.lang = userLang;
  i18n.on("languageChanged", (lng) => {
    document.documentElement.lang = lng;
  });
};

export default initI18n;
